export async function changeTrackConstraints(
  pc: RTCPeerConnection,
  stream: MediaStream,
  getTracks: (stream: MediaStream) => MediaStreamTrack[],
  kind: 'audio' | 'video',
  constraints: MediaStreamConstraints,
  error: (error: string) => void,
) {
  try {
    const transceiver = pc
      .getTransceivers()
      .find((s) => s.receiver.track.kind === kind)

    const sender = transceiver?.sender

    if (!sender) {
      console.log('Unable to find transceiver/sender')
      error('Unable to find transceiver/sender')
      return null
    }

    const existingTracks = getTracks(stream)
    if (
      existingTracks &&
      existingTracks.length
    ) {
      const rt = existingTracks
        .find((t) => t.id === sender.track?.id)
      if (rt) {
        try {
          stream.removeTrack(rt)
        } catch (e) {
          console.error('Error removing track from stream for renegotiation', e)
          error('Error calling onlocaltrack on removal for renegotiation')
        }
        try {
          rt.stop()
        } catch (e) {}
      }
    }

    sender.track?.stop()

    const newStream = await navigator.mediaDevices.getUserMedia(constraints)
    const [newTrack] = getTracks(newStream);

    (window as any).lastStream = newStream;
    (window as any).window.lastTrack = newTrack

    await sender.replaceTrack(newTrack)
    stream.addTrack(newTrack)

    return newTrack
  } catch (err) {
    console.error('Error replaceTrack', err)
    error('Error changeTrackContraints')
  }
  return null
}
